export enum ClientManagerSituationEnum {
  Ativo = 'Em Execução',
  Encerrado = 'Encerrada',
}
